import React, { useState } from 'react';
import TextField from '@mui/material/TextField';
import MenuItem from '@mui/material/MenuItem';
import Grid from '@mui/material/Grid';

export default function Localise_Render(props) {
  const { setNodeData, nodeData } = props;
  const [waypoints, ] = useState(["waypoint1", "waypoint2", "waypoint3"]);
  const [selected_waypoint, setSelectedWaypoint] = useState(nodeData && nodeData.type==="localise"? nodeData.selectedWaypoint: waypoints[0])
  setNodeData({
    type: "localise",
    waypoint: selected_waypoint
  })
  const handleChange = (event) => {
    setSelectedWaypoint(event.target.value)
    setNodeData({
      type: "localise",
      selectedWaypoint: event.target.value
    })
  }
  return(
    <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
    <TextField
    select
    id="outlined-required"
    label="Waypoint"
    defaultValue={selected_waypoint}
    value={selected_waypoint}
    name="robot_actions"
    style={{width: "100%"}}
    onChange={handleChange}
  >
  {waypoints.map((option) => (
      <MenuItem key={option} value={option}>
        {option}
      </MenuItem>
    ))}
  </TextField>
  </Grid>
  )
}